import React from 'react';
import dynamic from "next/dynamic";
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
// import Link from 'next/link';
import { cleanFirebaseId, ratingValue, cleanGUID, secToDate, cleanText } from '../../lib/utils';
import { createReviewId, characterLimit, characterLimitDisplay } from '../../lib/reviewUtils';
import { spacing, maxScreenSize, colors } from '../../lib/theme';
import { HeartFilled, HeartOutlined } from '@ant-design/icons';
import { Alert, Button, Checkbox, Input, message, Modal, Radio, Rate, Tooltip } from 'antd';
// import { setEpisodeRating, createEpisodeReview, editEpisodeReview, getUserEpisodeReview } from '../../actions';
// import { stat } from 'fs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import LoadingSpinner from '../Common/Loading';
// import RatingDialog from './RatingDialog';
// const { TextArea } = Input;

const RatingModalMiddle = dynamic(() => import("./RatingModalMiddle"), {
  ssr: false
});

class RatingModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = { ratingInit: -1, comment: '', privacyType: '', errorMessage: '', confirmLoading: false };
  }

  componentDidMount() {
    // const { podcastEpisode } = this.props;
    // const guidCleaned = cleanFirebaseId(podcastEpisode.guid);
    // const { ratingInit } = this.state;
    // const rating = ratingInit > 0 ? ratingInit : (personalValues && typeof personalValues[guidCleaned] !== 'undefined' && personalValues[guidCleaned].rating || -1);
    // console.log('rating : ' + rating);
    // if (rating > 0) {
    //   this.setState({ edit: true })
    // }
  }

  showRatingsModal = () => {
    const { podcastEpisode, userDetails } = this.props;
    if (!userDetails) {
      message.warning('Please sign in to add to Favourites.');
      return;
    }
    console.log('rating');
    // this.props.getUserEpisodeReview(userDetails.uid, podcastEpisode);

    this.setState({
      visible: true,
    });
  }

  callParent = () => {
    this.setState({
      visible: false,
    });
  }

  // callbackChild = (val, data) => {
  //   if (val === true) {
  //     const { rating, comment, privacyType } = data;
  //     this.handleOk(rating, comment, privacyType);
  //   } else {
  //     this.setState({ visible: false });
  //   }
  // }

  render() {
    const { errorMessage, confirmLoading, ratingInit, comment, privacyType, visible } = this.state;
    const { userDetails, podcastEpisode, personalRatingsValues, reviewsState, parent, privacyTypeParent } = this.props;
    // const { loadingReview } = this.props.loadingState;
    const guidCleaned = cleanFirebaseId(podcastEpisode.guid);
    // const { personalValues } = this.props.personalDetails;
    const rating = ratingInit > 0 ? ratingInit : (personalRatingsValues && typeof personalRatingsValues[guidCleaned] !== 'undefined' && personalRatingsValues[guidCleaned].rating || -1);

    // const episodeId = cleanGUID(podcastEpisode); // 
    // const reviewId = createReviewId(episodeId, userDetails && userDetails.uid); // 
    // const reviewDetails = reviewsState && reviewsState[`${reviewId}`] || {};
    // const privacyTypeDefault = reviewDetails && reviewDetails['privacyType'] || privacyTypeParent;
    // const privacy = privacyType !== '' ? privacyType : privacyTypeDefault;
    // const commentsDefault = reviewDetails && reviewDetails['comment'] || '';
    // const commentsValue = comment !== '' ? comment : commentsDefault;

    // const rating = (personalValues && typeof personalValues[guidCleaned] !== 'undefined' && personalValues[guidCleaned].rating) || -1;
    // const { userDetails } = this.props;
    let okText = 'Ok'; // rating > 0 ? 'Edit' : 'Ok';

    return (
      <div className='main'>
        {visible && <RatingModalMiddle callParent={this.callParent} visible={visible}
          podcastEpisode={podcastEpisode}
        />}
        {/* <Modal
          bodyStyle={{ minHeight: '200px' }}
          title={`${cleanText(podcastEpisode.title)}`}
          visible={this.state.visible}
          // confirmLoading={confirmLoading}
          onCancel={this.handleCancel}
          footer={null}
        >
          {loadingReview ? <LoadingSpinner /> :
            <RatingDialog podcastEpisode={podcastEpisode}
              rating={reviewDetails.rating || -1}
              comment={reviewDetails.comment || ''}
              privacyType={reviewDetails.privacyType || privacyTypeParent}
              confirmLoading={confirmLoading}
              callbackParent={this.callbackChild} />}
        </Modal> */}

        {/* <div style={{paddingLeft: '25%'}}> */}
        <div className='rating-main'>
          <a style={{ fontSize: '1.1em', color: `${colors.primary}` }} onClick={this.showRatingsModal}>
            {parent === 'personalReview' ?
              <FontAwesomeIcon icon='edit' />
              : (parent === 'episodeReviewList' ?
                <Button type=''>Write Review</Button> :
                <Tooltip title="Add to Favourite">
                  {rating && rating > 0 &&
                    <span className='rating'>{ratingValue(rating, 0)}</span>}
                  {/* <LegacyIcon type="heart" theme={rating && rating > 0 ? 'filled' : ''} /> */}
                  {rating && rating > 0 ? <HeartFilled /> : <HeartOutlined />}
                </Tooltip>)}
          </a>
        </div>

        <style jsx>
          {`
            .main {
              // display: inline;
              // margin-right: 0.25em;
              max-width: 36px;
            }
            .rating {
              // color: black;
              padding-right: 2px;
              // float: left;
              // margin-top: 2px;
              // margin-left: 4px;
              // display: inline;
              // margin-right: 0.25em;
            }
            .rating-main {
              // padding-left: 1px;
              max-width: 36px;
            }
            :global(.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)) {
              background: ${colors.primary};
              border-color: ${colors.primary};
            }
            @media ${maxScreenSize.laptop} {
              .rating-main {
                  // display: none;
                  // padding-left: 20%;
                  // padding-right: 20%;
              }
              .rating-main {
                max-width: 32px;
              }
            }
        `}
        </style>
      </div>
    );
  }
}

RatingModal.defaultProps = {
  privacyTypeParent: 'private',
}

RatingModal.propTypes = {
  loadingState: PropTypes.object,
  visible: PropTypes.bool,
  // callbackParent: PropTypes.func,
  rating: PropTypes.number,
  parent: PropTypes.string,
  privacyTypeParent: PropTypes.string,
  userDetails: PropTypes.object,
  podcastEpisode: PropTypes.object,
  personalRatingsValues: PropTypes.object,
  reviewsState: PropTypes.object,
  // setEpisodeRating: PropTypes.func,
  // createEpisodeReview: PropTypes.func,
  // editEpisodeReview: PropTypes.func,
  // getUserEpisodeReview: PropTypes.func,
}

const mapStateToProps = (state) => {
  return {
    userDetails: state.userDetails,
    personalRatingsValues: state.personalRatingsValues,
    reviewsState: state.reviewsState,
    loadingState: state.loadingState,
    // userPlaylists: state.userPlaylists,
  }
}

// export default podcast;
const mapDispatchToProps = (dispatch) => {
  return {
    // setEpisodeRating: bindActionCreators(setEpisodeRating, dispatch),
    // createEpisodeReview: bindActionCreators(createEpisodeReview, dispatch),
    // editEpisodeReview: bindActionCreators(editEpisodeReview, dispatch),
    // getUserEpisodeReview: bindActionCreators(getUserEpisodeReview, dispatch)
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(RatingModal)